import React, { FC, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import Select from "react-select";
import { ImInfo } from "react-icons/im";
import Tooltip from '@material-ui/core/Tooltip';

import Row from "../Layout/Row";
import ButtonField from "../Fields/ButtonField";
import Col from "../Layout/Col";
import { useGetDayName } from "../../helpers/dateHelpers";
import TimeLine from "./TimeLine";
import { getFullDayEvents, getTimeLineValues } from "../../helpers/calendarHelpers";
import CreateEventCalendarBody from "./CreateEventCalendarBody";
import CalendarBody from "./CalendarBody";
import EventSort from "./EventSort";
import {
    getCalendarSettings,
    getCalendarStartDate,
    getCreateEventMode,
    getWorkTimeEnd,
    getWorkTimeStart,
} from "../../redux/selectors/calendarSelectors";
import {
	getGrouppedTemplatesFilterOptions,
} from "../../redux/selectors/filterOptionsSelectors";
import {
    setCreateEventMode,
    setSelectedTemplateId,
	setSelectedEventIdForPlanning,
} from "../../redux/actions/calendarActions";
import {filterTemplatesByBranchId, getCalendarTemplateGroups} from "../../helpers/helpers";
import {getBranchFilter, getFilters, getTemplateGroupFilter} from "../../redux/selectors/filterSelectors";
import { getUser } from "../../redux/selectors/userSelectors";
import { getEvents } from "../../redux/selectors/eventsSelectors";

const DayCalendar: FC = () => {
    const dispatch = useDispatch();
    const templateOpts = useSelector(getGrouppedTemplatesFilterOptions);
	const branchId = useSelector(getBranchFilter);
    const templateGroupId = useSelector(getTemplateGroupFilter);
    const calendarStartDate = useSelector(getCalendarStartDate);
    const workTimeStart = useSelector(getWorkTimeStart);
    const workTimeEnd = useSelector(getWorkTimeEnd);
    const createEventMode = useSelector(getCreateEventMode);
    const calendarSettings = useSelector(getCalendarSettings);
    const user = useSelector(getUser);
    const events = useSelector(getEvents);
    const filters = useSelector(getFilters);
    const timeLineValues = getTimeLineValues(workTimeStart, workTimeEnd, "day");
    const { t } = useTranslation();

    // const handleCreateEvent = () => {
    //     newEvent &&
    //         createEventFromAPI(newEvent)
    //             .then(() => {
    //                 // console.log("created event", newEvent);
    //             })
    //             .catch((err) => console.log(err));
    //     // TODO: update resources
    // };
    const calendarTemplateGroups = useMemo(() => getCalendarTemplateGroups(calendarSettings, filters.calendarId), [calendarSettings, filters.calendarId]);

    return (
        <div className="calendar-container">
            <div className="calendar-head">
                <Row>
                    <Col width={1} className="calendar-head-event">
                        <Row gap="5px">
                            {!createEventMode ? (
                                <Col>
                                    {user.facturabill_modify && (
                                        <Select
                                            placeholder={t("template")}
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            options={filterTemplatesByBranchId(templateOpts, branchId, templateGroupId, calendarTemplateGroups)}
                                            onChange={(val) => {
                                                dispatch(
                                                    // @ts-ignore
                                                    setSelectedTemplateId(val.value)
                                                );
                                                val &&
                                                dispatch(
                                                    setCreateEventMode(true)
                                                );
                                            }}
                                        />
                                    )}
                                    <EventSort />
                                    {/* <Row gap="5px">
                                        <Col>
                                            <ButtonField
                                                className="add-event-button"
                                                size="small"
                                                onClick={() => sortEvents('name')}
                                            >
                                                {t("Updated")}
                                            </ButtonField>
                                        </Col>
                                        <Col>
                                            <ButtonField
                                                className="add-event-button"
                                                size="small"
                                                onClick={() => sortEvents('name')}
                                            >
                                                {t("name")}
                                            </ButtonField>
                                        </Col>
                                        <Col>
                                            <ButtonField
                                                className="add-event-button"
                                                size="small"
                                                onClick={() => sortEvents('startDate')}
                                            >
                                                {t("Time")}
                                            </ButtonField>
                                        </Col>
                                    </Row> */}
                                    {/*<SelectField<string>*/}
                                    {/*    value={selectedTemplateId}*/}
                                    {/*    onChange={(val) => {*/}
                                    {/*        dispatch(*/}
                                    {/*            setSelectedTemplateId(val)*/}
                                    {/*        );*/}
                                    {/*        val &&*/}
                                    {/*            dispatch(*/}
                                    {/*                setCreateEventMode(true)*/}
                                    {/*            );*/}
                                    {/*    }}*/}
                                    {/*    label={t("template")}*/}
                                    {/*    options={templateOpts}*/}
                                    {/*/>*/}
                                </Col>
                            ) : (
                                <>
                                    {/*<Col>*/}
                                    {/*    <ButtonField*/}
                                    {/*        className="add-event-button"*/}
                                    {/*        onClick={handleCreateEvent}*/}
                                    {/*    >*/}
                                    {/*        {t("create_event")}*/}
                                    {/*    </ButtonField>*/}
                                    {/*</Col>*/}
                                    <Col>
                                        <ButtonField
                                            className="add-event-button"
                                            onClick={() => {
                                                dispatch(
                                                    setSelectedTemplateId(null)
                                                );
												dispatch(
													setSelectedEventIdForPlanning(null)
												);
                                                dispatch(
                                                    setCreateEventMode(false)
                                                );
                                            }}
                                        >
                                            {t("cancel")}
                                        </ButtonField>
                                        <EventSort />
                                    </Col>
                                </>
                            )}
                        </Row>
                    </Col>
                    <Col width={7} align="center" className="calendar-head-day">
                        {useGetDayName(calendarStartDate)}
                        <br />
                        <Row align="center" justify="center">
                            {format(calendarStartDate, "dd.MM.yyyy")}
                            {getFullDayEvents(calendarStartDate, events).length > 0 && (
                                <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{
                                    getFullDayEvents(calendarStartDate, events).map((event, index) => (
                                        <span key={index}>{event.name}{"\n"}</span>
                                    ))
                                }</span>} arrow>
                                    <div>
                                        <ImInfo size="12px" style={{marginLeft: '5px', color: 'red'}} />
                                    </div>
                                </Tooltip>
                            )}
                            </Row>
                    </Col>
                </Row>
            </div>
            <TimeLine timeLineValues={timeLineValues} />
            <div className="calendar-body-container">
                <div className="calendar-body">
                    <div className="body-timeline">
                        {timeLineValues.map((tl, index) => (
                            <React.Fragment key={index}>
                                {tl.showLine && (
                                    <div
                                        className="line"
                                        style={{
                                            marginLeft: `${tl.step}px`,
                                        }}
                                    />
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                    {createEventMode ? (
                        <CreateEventCalendarBody />
                    ) : (
                        <CalendarBody />
                    )}
                </div>
            </div>
        </div>
    );
};

export default DayCalendar;
